import { render, staticRenderFns } from "./editActions.vue?vue&type=template&id=028d0fac&"
import script from "./editActions.vue?vue&type=script&lang=js&"
export * from "./editActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports